import React from "react";
//#region types
import { RadioGroupProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { RadioSelectionGroup } from "components/common";
//#endregion

function RadioGroup(props: RadioGroupProps) {
  const { setValue, items, disabled, value } = props;

  const onChangeHandler = (e: React.ChangeEvent<any>, value: string) => {
    // eslint-disable-next-line eqeqeq
    const selectedItem = items?.find((x) => x.id == value);
    setValue(selectedItem?.id);
  };

  return (
    <RadioSelectionGroup
      items={items}
      onChange={onChangeHandler}
      row
      readOnly={disabled}
      value={value}
      data-testid={`${props.name}RadioGroup`}
    />
  );
}

export default RadioGroup;
